import { jsx as _jsx } from "react/jsx-runtime";
import { ThemeProvider, useTheme } from 'react-jss';
import { DefaultTheme } from './defaultTheme';
import { intersectThemes } from './utils';
export const CustomThemeProvider = ({ theme, children }) => {
    const themeToUse = intersectThemes(DefaultTheme, theme);
    return _jsx(ThemeProvider, { theme: themeToUse, children: children });
};
export const useCustomTheme = useTheme;
export default CustomThemeProvider;
